export const WHATSAPP_SUPPORT_NUMBER = '5511985576395';
export const WHATSAPP_SUPPORT_DISPLAY = '(11) 98557-6395';
export const CONTACT_EMAIL = 'contato@gabriela.app.br';
export const SUPPORT_EMAIL = 'suporte@gabriela.app.br';
export const getWhatsAppSupportLink = (text) =>
  `https://wa.me/${WHATSAPP_SUPPORT_NUMBER}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
